import { render, staticRenderFns } from "./searchOrderByProduct.vue?vue&type=template&id=1b233660&"
import script from "./searchOrderByProduct.vue?vue&type=script&lang=js&"
export * from "./searchOrderByProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports